export default "//cdn.scentbird.com/assets/frontbird-site/images/mobile_e084c1.jpg";